import type { Snapshot } from "./replay.ts";
import snapshotUrl from "./snapshot.json?url";

let loading: Promise<Snapshot> | null = null;

export const loadSnapshot = (): Promise<Snapshot> => {
  loading ??= import.meta.env.SSR
    ? import("./snapshot.json").then((recorded) => recorded.default as Snapshot)
    : fetch(snapshotUrl).then(async (response) => {
        if (!response.ok) throw new Error(`the demo snapshot answered ${response.status}`);
        return (await response.json()) as Snapshot;
      });
  return loading;
};
